import * as React from 'react';
import { twMerge } from 'tailwind-merge';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={twMerge(
        'flex min-h-[80px] w-full rounded-lg px-3 py-2 text-base placeholder:text-grey-600 placeholder:font-medium placeholder:text-base focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
